import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {MatChipInputEvent} from '@angular/material/chips';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import {MatSliderModule} from '@angular/material/slider';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-efactura-received-invoices',
  templateUrl: './efactura-received-invoices.component.html',
  styleUrls: ['./efactura-received-invoices.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class EFacturaReceivedInvoicesComponent implements OnInit {

  searchPartnerUpdate = new Subject<string>();

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) { 

    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

     // Debounce search.
     this.searchPartnerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetPartnersFiltered(value, this.countryID, true);
      });

  }

  ngOnInit(): void {
    this.showFilter = false;
    this.DocumentBodyLoading = false;
    this.InitializeFilter();
    this.GetInvoiceMasterData();
    this.GetEFacturaReceivedInvoicesFromDocumentsDBFiltered();
    this.countryID = null;
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  GetEFacturaReceivedInvoicesFromDocumentsDBFiltered(page = 1){

    this.Filter.Pager.PageIndex = page;

    if(this.Filter.DisplayAllPagesTotals == true){
      this.Filter.ExchangeToTargetCurrency = false;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }
    
    this.loading = true;
    this.showFilter = false;

    this.service.GetEFacturaReceivedInvoicesFromDocumentsDBFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Invoices = response["Rows"];
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
      
      this.loading = false;
    });
  }

  AllSelected:boolean;
  showInvoiceVisualizer:boolean;
  loading:boolean;
  EFacturaStatuses:any[];
  Currencies:any[];
  DocTypes:any[];
  DecimalPrecisions:any[];
  AccountingSeries:any[];
  Administrations:any[];
  MeasuringUnits:any[];
  VATRates:any[];
  ProductGeneralTypes:any[];
  DocumentStatuses:any[];
  Periods:any[];
  Languages:any[];
  PaymentTerms:any[];
  DiscountTypes:any[];
  Agents:any[];
  Countries:any[];
  CashCollectTypes:any[];
  CashCollections:any[];
  ShowSuggestionCashCollectionsContainer:boolean;
  CashTotals:any[];
  SortingOrders:any[];
  CountryFilterOptions:any[];
  PartnerTypes:any[];
  TranzactionTypes:any[];
  InvoiceModels:any[];
  EFacturaDownloadStatuses:any[];

  SelectAll(){
    this.Invoices.forEach(r => {
      r.IsSelected = this.AllSelected;
    });
  
    this.CheckIfAnyChecked();
  }

  AnyChecked:boolean;

  CheckIfAnyChecked(){
    this.AnyChecked = false;

    this.Invoices.forEach(element => {
      if(element.IsSelected){
        this.AnyChecked = true;
      }
    });
  }

  GetInvoiceMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.service.GetInvoiceMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = response["Currencies"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.AccountingSeries = response["AccountingSeries"];
        this.Languages = response["Languages"];
        this.PaymentTerms = response["PaymentTerms"];
        this.Administrations = response["Administrations"];
        this.MeasuringUnits = response["MeasuringUnits"];
        this.VATRates = response["VATRates"];
        this.ProductGeneralTypes = response["ProductGeneralTypes"];
        this.DiscountTypes = response["DiscountTypes"];
        this.Agents = response["Agents"];
        this.DocTypes = response["DocTypes"];
        this.Periods = response["Periods"];
        this.DocumentStatuses = response["DocumentStatuses"];
        this.Countries = response["Countries"];
        this.CashCollectTypes = response["CashCollectTypes"];
        this.SortingOrders = response["SortingOrders"];
        this.CountryFilterOptions = response["CountryFilterOptions"];
        this.PartnerTypes = response["PartnerTypes"];
        this.TranzactionTypes = response["TranzactionTypes"];
        this.InvoiceModels = response["InvoiceModels"];
        this.EFacturaStatuses = response["EFacturaStatuses"];
        this.Filter.SortingOrder = this.SortingOrders[0];
        this.EFacturaDownloadStatuses = response["EFacturaDownloadStatuses"];
      }
   
      this.parent.loading = false;
    });
  }

  DocumentBodyLoading:boolean;
  searchTerm:string;
  pageSize:number = 50;
  Partners:any[];
  resultsLength:number;
  countryID:number;
  
  activeFilters:{[k: string]: any} = [];
  Products:any[];
  CurrentInvoice: {[k: string]: any} = {};
  partner: {[k: string]: any} = {};
  Filter: {[k: string]: any} = {};
  showFilter:boolean;
  Invoices:any[];
  Totals:any[];

  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  InitializeFilter(){

    this.Filter = {};

    this.Filter.Product = "";
    this.Filter.Partner = "";
    this.Filter.VATNumber = "";

    this.Filter.DocumentNumber = "";

    this.Filter.Status = {};
    this.Filter.Status = null;
    
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;

    this.Filter.Period = {};
    this.Filter.Period = null;

    this.Filter.SortingOrder = {};
    this.Filter.SortingOrder = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;
  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:this.pageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];

         if(this.Partners.length == 1){
          this.partner = this.Partners[0]; this.resultsLength = 0; this.searchTerm = this.Partners[0].Name; this.Filter.Partner = this.Partners[0].Name; this.AddActiveFilter(this.Partners[0].Name, 'Partner');
          this.GetEFacturaReceivedInvoicesFromDocumentsDBFiltered();
         }
        }
     
        this.parent.loading = false;
      });
    }
  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.showFilter = false;
      this.GetEFacturaReceivedInvoicesFromDocumentsDBFiltered();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Administration"){
      this.Filter.Administration = null;
    }
    else if(filterType == "Series"){
      this.Filter.AccountingSeries = null;
    }
    else if(filterType == "DocStatus"){
      this.Filter.DocumentStatus = null;
    }
    else if(filterType == "DocumentNumber"){
      this.Filter.DocumentNumber = null;
    }
    else if(filterType == "Product"){
      this.Filter.Product = null;
    }
    else if(filterType == "Partner"){
      this.Filter.Partner = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "Country"){
      this.Filter.Country = null;
    }
    else if(filterType == "Currency"){
      this.Filter.Currency = null;
    }
    else if(filterType == "InvoiceDocType"){
      this.Filter.InvoiceDocType = null;
    }
    else if(filterType == "ShippingCompany"){
      this.Filter.ShippingCompany = null;
    }
    else if(filterType == "EFacturaStatus"){
      this.Filter.EFacturaStatus = null;
    }

    this.GetEFacturaReceivedInvoicesFromDocumentsDBFiltered();
}

}
